import React from 'react'

export const wisconsinSetupVars = {
  siteId: 'wisconsin',
  pathPrefix: '/wi',
  menuHeader: "Discover Wisconsin's Solution for:",
  appUrl: 'https://wi.headed2.com',
  logoImg: '/images/assets/wisconsin/horizontal/dark.svg',
  headerTitle: `The Wisconsin CareerExplorer is a system designed for Wisconsin`
}
